import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NavigationService } from 'src/app/services/navigation.service';
import { ProductService } from 'src/app/services/product.service';
import { Location } from '@angular/common';
import { ManufacturerService } from 'src/app/services/manufacturer.service';
import { AlertService } from 'src/app/services/alert.service';



@Component({
  selector: 'app-productupdatepopup',
  templateUrl: './productupdatepopup.component.html',
  styleUrls: ['./productupdatepopup.component.scss']
})
export class ProductUpdatePopupComponent implements OnInit {
  showNotes: boolean = true;
  form: any;
  id: any;

  constructor(
    private formBuilder: FormBuilder,
    private productService: ProductService,
    private manufacturerService: ManufacturerService,
    private alertService: AlertService,


    private _location: Location,


    public dialogRef: MatDialogRef<ProductUpdatePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedToEdit: any,

    public addServiceDialog: MatDialog,
    private navigationService: NavigationService,
  ) { this.id = this.dataRecievedToEdit.id }


  ngOnInit(): void {

    this.showNotes = true;
    this.initializeValidators();
  }


  initializeValidators() {
    this.form = this.formBuilder.group({
      remarks: ['', Validators.required]
    })
  }


  next(isProceed) {
    this.dialogRef.close(isProceed);

  }

  goToAction(item: number) {
    // var data = {
      this.dataRecievedToEdit.approvedStatusType = item;
      this.dataRecievedToEdit.remarks = this.form.value.remarks;
      // approvedStatusType: item,
      // remarks: this.form.value.remarks
    // }    
    this.productService.productUpdate(this.dataRecievedToEdit).subscribe(res => {
      if (res && res.isSuccess) {
        this.alertService.success('Product Updated Successfully');
        this._location.back();
      }
      else {
        this.alertService.error(res.htmlFormattedFailures);
      }
    });
  }

}
